import { render, staticRenderFns } from "./MensagemPlanoAnual.vue?vue&type=template&id=4a4097d4"
import script from "./MensagemPlanoAnual.vue?vue&type=script&lang=js"
export * from "./MensagemPlanoAnual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports